<p-progressSpinner *ngIf="!initialized" [style]="{width: '50px', height: '50px'}" fxFlex="1 1 auto" class="spinner"  animationDuration="2s"></p-progressSpinner>

<p-table *ngIf="initialized" class="significant-ladder liquitics-compact-table" [value]="tableData" scrollable="true"  scrollHeight="50vh"[rows]="12" [paginator]="false" styleClass="p-datatable-striped">
    <ng-template pTemplate="caption">
        {{title}}
    </ng-template>
    <ng-template pTemplate="header">
        <tr>
            <th style="width:30%" [pSortableColumn]="significantAttribute"> 
                <span> </span>
                <p-sortIcon [field]="'significantAttribute'"></p-sortIcon>
            </th>
            <th [pSortableColumn]="'day1Amount'">
                {{headerDates[0]}}
                <p-sortIcon [field]="'day1Amount'"></p-sortIcon>
            </th>
            <th [pSortableColumn]="'day2Amount'">
                {{headerDates[1]}}
                <p-sortIcon [field]="'day2Amount'"></p-sortIcon>
            </th>
            <th [pSortableColumn]="'day3Amount'">
                {{headerDates[2]}}
                <p-sortIcon [field]="'day3Amount'"></p-sortIcon>
            </th>
            <th [pSortableColumn]="'day4Amount'">
                {{headerDates[3]}}
                <p-sortIcon [field]="'day4Amount'"></p-sortIcon>
            </th>
            <th [pSortableColumn]="'day5Amount'">
                {{headerDates[4]}}
                <p-sortIcon [field]="'day5Amount'"></p-sortIcon>
            </th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-row>
        <tr>
            <td style="width:30%" >{{row[significantAttribute]}}</td>
            <td [style]="{'text-align':'center'}">
                <span>{{row.day1Amount | currencyrounding:2:row.currency:false | negativeparentheses}}</span>
            </td>
            <td [style]="{'text-align':'center'}">
                <span>{{row.day2Amount | currencyrounding:2:row.currency:false | negativeparentheses}}</span>
            </td>
            <td [style]="{'text-align':'center'}">
                <span>{{row.day3Amount | currencyrounding:2:row.currency:false | negativeparentheses}}</span>
            </td>
            <td [style]="{'text-align':'center'}">
                <span>{{row.day4Amount | currencyrounding:2:row.currency:false | negativeparentheses}}</span>
            </td>
            <td [style]="{'text-align':'center'}">
                <span>{{row.day5Amount | currencyrounding:2:row.currency:false | negativeparentheses}}</span>
            </td>
        </tr>
    </ng-template>


    <!-- <p-header>{{title}}</p-header>
    <p-column [styleClass]="'col-entity'" [field]="significantAttribute" header=" " [sortable]="true" [style]="{'width':'30%','text-align':'center'}"></p-column>
    <p-column [styleClass]="'col-day-one'" field="day1Amount" [header]="headerDates[0]" [sortable]="true" [style]="{'text-align':'center'}">
        <ng-template let-row="rowData" pTemplate="body">
            <span>{{row.day1Amount | currencyrounding:2:row.currency:false | negativeparentheses}}</span>
        </ng-template>
    </p-column>
    <p-column [styleClass]="'col-day-two'" field="day2Amount" [header]="headerDates[1]" [sortable]="true" [style]="{'text-align':'center'}">
        <ng-template let-row="rowData" pTemplate="body">
            <span>{{row.day2Amount | currencyrounding:2:row.currency:false | negativeparentheses}}</span>
        </ng-template>
    </p-column>
    <p-column [styleClass]="'col-day-three'" field="day3Amount" [header]="headerDates[2]" [sortable]="true" [style]="{'text-align':'center'}">
        <ng-template let-row="rowData" pTemplate="body">
            <span>{{row.day3Amount | currencyrounding:2:row.currency:false | negativeparentheses}}</span>
        </ng-template>
    </p-column>
    <p-column [styleClass]="'col-day-four'" field="day4Amount" [header]="headerDates[3]" [sortable]="true" [style]="{'text-align':'center'}">
        <ng-template let-row="rowData" pTemplate="body">
            <span>{{row.day4Amount | currencyrounding:2:row.currency:false | negativeparentheses}}</span>
        </ng-template>
    </p-column>
    <p-column [styleClass]="'col-day-five'" field="day5Amount" [header]="headerDates[4]" [sortable]="true" [style]="{'text-align':'center'}">
        <ng-template let-row="rowData" pTemplate="body">
            <span>{{row.day5Amount | currencyrounding:2:row.currency:false | negativeparentheses}}</span>
        </ng-template>
    </p-column> -->
</p-table>